import {svgjs} from 'svg.js';
import {Init} from 'core/Init';

import {APP_EVT, LIBRARY_KEY} from 'core/config/constants';
import {DataOffice} from 'core/services/DataOffice';

declare var SVG: svgjs.Library;


class DataLibrary extends DataOffice {

	private variantQueue: string[];
	private original_id: string;

	/**
	 *
	 *
	 */
	constructor() {

		super();

		Init.emitter.on(APP_EVT.SAVE_LIBRARY_VARIATIONS, this.initSaveLibraryVariations);
		Init.emitter.on(APP_EVT.SHOW_LIBRARY_LIST_MODAL, this.showLibraryListModal);
		Init.emitter.on(APP_EVT.RETRIEVE_LIBRARY_LIST, this.retrieveLibraryList);
		Init.emitter.on(APP_EVT.LIBRARY_LIST_SUCCESS, this.libraryListSuccess);
		Init.emitter.on(APP_EVT.SAVE_SUCCESS, this.librarySaveSuccess);

		let btns: Array<any> = [];

		btns['#btn-library-save'] = [APP_EVT.SAVE_CHECK];
		btns['#btn-library-save-over-yes'] = [APP_EVT.SAVE_DESIGN];
		btns['#btn-save-variations'] = [APP_EVT.SAVE_LIBRARY_VARIATIONS];
		btns['#btn-modal-library-list'] = [APP_EVT.SHOW_LIBRARY_LIST_MODAL];

		for (let btn in btns) {

			$(btn).on('click', function (evt) {

				Init.emitter.emit(btns[btn][0], ...btns[btn].slice(1), this);

			});
		}

	}


	initSaveLibraryVariations = (): void => {

		this.variantQueue = [];

		$(this.modal + ' .msg').removeClass('alert-info alert-danger').html('');

		$('#modal-library-save #status').addClass('alert-info');
		$('#modal-library-save #status').append('saved variations:<br>');

		if (Init.design_name != '') {

			let name_original: string = Init.design_name;
			this.original_id = Init.design_id;

			if (name_original.slice(-3) != 'C_O') {

				let msg: string = 'This design name does not end with C_O, which means that it is probably not a colored-fence design.';
				msg += '<br>Please start with a colored-fence design when creating variations.';
				//console.log(msg);
				$('#modal-library-save #status').show().html(msg).addClass('alert-danger');

				return;
			}


			let name_original_mirror: string = name_original.replace(name_original.slice(-1), LIBRARY_KEY.MIRROR);

			let name_plain: string = name_original.replace(name_original.slice(-3), LIBRARY_KEY.PLAIN + '_' + LIBRARY_KEY.ORIGINAL);
			let name_plain_mirror: string = name_original.replace(name_original.slice(-3), LIBRARY_KEY.PLAIN + '_' + LIBRARY_KEY.MIRROR);

			let name_cutout: string = name_original.replace(name_original.slice(-3), LIBRARY_KEY.CUTOUT + '_' + LIBRARY_KEY.ORIGINAL);
			let name_cutout_mirror: string = name_original.replace(name_original.slice(-3), LIBRARY_KEY.CUTOUT + '_' + LIBRARY_KEY.MIRROR);


			let user_name: string = 'sean'; //String($(this.modal + ' #user_name').val());

			// save original
			this.saveVariant(name_original, user_name);

			// save original mirrored
			this.saveVariant(name_original_mirror, user_name, APP_EVT.FLIP_DESIGN, 'across');

			// save plain mirrored
			this.saveVariant(name_cutout_mirror, user_name, APP_EVT.CHANGE_FENCES_TO_CUTOUT);

			// save plain
			this.saveVariant(name_cutout, user_name, APP_EVT.FLIP_DESIGN, 'across');

			// save cutout
			this.saveVariant(name_plain, user_name, APP_EVT.CHANGE_FENCES_TO_PLAIN);

			// save cutout mirrored
			this.saveVariant(name_plain_mirror, user_name, APP_EVT.FLIP_DESIGN, 'across');

		}
	}


	saveVariant = (design_name: string, user_name: string, emit_id: number = null, emit_arg: string = null): void => {

		if (!isNaN(emit_id)) {
			Init.emitter.emit(emit_id, emit_arg);
		}
		this.saveDesign(design_name, user_name);

	}


	/**
	 *
	 */
	librarySaveSuccess = (data): void => {

		if (this.variantQueue) {

			this.variantQueue.push(data.design_name);

			$('#modal-library-save #status').append('- ' + data.design_name + '<br>');

			//console.log(this.variantQueue, Date.now());

			if (this.variantQueue.length == 6) {

				Init.emitter.emit(APP_EVT.RETRIEVE_DESIGN_BY_ID, this.original_id, 'library');

			}
		}

	};


	/**
	 *
	 */
	showLibraryListModal = (): void => {

		$('#modal-library-list').modal('show');

		let _that = this;

		$('#btn-library-mode')
			.removeClass('btn-type-muted')
			.addClass('btn-type-alert');

		$('#modal-library-list #library-list').on('click', '.design-list-row', function (this) {

			let design_id: string = $(this).data('id');
			let source: string = 'library';

			Init.emitter.emit(APP_EVT.RETRIEVE_DESIGN_BY_ID, design_id, source);

			_that.closeLibraryListModal();

		});

		$('#modal-library-list #btn-retrieve-library-list').on('click', function (this) {

			let name = $('#modal-library-list #retrieve-library-filter').val();

			Init.emitter.emit(APP_EVT.RETRIEVE_LIBRARY_LIST, name);

		});

		$('#modal-library-list #retrieve-library-filter').on('input', function (this) {
			console.log('showLibraryListModal');
			let filter: any = $('#modal-library-list #retrieve-library-filter').val();

			Init.emitter.emit(APP_EVT.RETRIEVE_LIBRARY_LIST, filter);

		});
	}


	/**
	 *
	 */
	closeLibraryListModal = (): void => {

		$('#modal-library-list').modal('hide');
		$('#btn-retrieve-library-list').off('click');
		$('#library-list').off('click');

	}



	/**
	 *
	 */
	retrieveLibraryList = (filter: string): void => {

		let data: any = {};

		data.filter = filter;
		data.series_id = Init.series_id;
		//data.designed_by = $('#retrieve-user-email').val();

		$.ajax({
			type: 'POST',
			url: '/data/libraryList',
			dataType: 'json',
			data: data
		})
			.done(function (data) {
				Init.emitter.emit(APP_EVT.FLASH_SUCCESS, data);
			})
			.fail(function (data) {
				Init.emitter.emit(APP_EVT.FLASH_ERROR, data);
			})
			.always(function (data) {
				Init.emitter.emit(APP_EVT.LIBRARY_LIST_SUCCESS, data);
			});

	};

	/**
	 *
	 * @param data
	 */
	libraryListSuccess = (data): void => {

		let modal: string = '#modal-library-list';
		let status: string;

		let str = `<table class="table table-hover table-sm">
        <thead><tr>
        <th style="width:35%">design name</th>
        <th style="width:15%">library id</th>
        <th style="width:10%">status</th>
        <th class="text-end" colspan="2" style="width:30%">design date</th>
        </tr></head>`;

		//console.log(data);

		if (data.length) {

			for (let i of data) {

				if (i.app_version != null) {
					let app_version: string[] = i.app_version.split('-');
					//console.log(app_version);
					status = (!app_version[0] || app_version[0] != 'builder') ? 'disabled' : '';
				}

				str += `<tr class="design-list-row ${status}" data-id="${i.id}">
                <td>${i.design_id}</td>
                <td>${i.library_id}</td>
                <td>${i.status_id}</td>
                <td class="text-end">${i.design_date_view}</td>
                <td class="text-end">${i.design_time_view}</td></tr>`;

			}

		} else {

			str += '<tr class="design-list-row"><td colspan="3">no designs found for this user</td></tr>';

		}
		str += '</table>';

		$(modal + ' #library-list').html(str);

	};

	/** **************************************************************
	 *                                   GETTERS - SETTERS
	 */

}

export {DataLibrary};

